export default __webpack_public_path__ + "static/media/plain-sticker-l.136fb76f.png";